export default __webpack_public_path__ + "static/media/ic_kyrgyzstan.7fc4f3e6.svg";